export interface Participant {
  name: string;
  title: string;
}

export type TaskStatus = 'pending' | 'in_progress' | 'completed';

export interface TaskItem {
  id: string;
  description: string;
  assignee: string;
  deadline: string | null;
  status: TaskStatus;
}

export interface DepartmentTasks {
  department: string;
  tasks: TaskItem[];
}

export interface DockingAttachment {
  id: string;
  fileName: string;
  filePath: string;
  fileSize: number;
  uploadedAt: string;
}

export type Maturity = 1 | 2 | 3 | 4 | 5;

export interface DockingRecord {
  id: string;
  parkId: string;
  dockedAt: string;
  ourParticipants: Participant[];
  counterpartyOrg: string;
  counterpartyParticipants: Participant[];
  summary: string;
  blockers: string;
  blockerResolved: boolean;
  blockerResolvedAt: string | null;
  /** 后续工作安排 */
  followUpPlan: string;
  memos: DockingAttachment[];
  minutes: DockingAttachment[];
  taskAssignments: DepartmentTasks[];
  /** 项目成熟度 1~5 星 */
  maturity: Maturity | null;
  createdAt: string;
  updatedAt: string;
  archived: boolean;
}

export interface DockingFilter {
  parkLevel: 'all' | 'national' | 'provincial' | 'pending';
  maturity: Maturity | null;
  dateRange: [string, string] | null;
}

export const DEFAULT_DOCKING_FILTER: DockingFilter = {
  parkLevel: 'all',
  maturity: null,
  dateRange: null,
};

export interface DockingStatistics {
  dockedNational: number;
  dockedProvincial: number;
  dockedPending: number;
  totalNational: number;
  totalProvincial: number;
  totalPending: number;
}

/** Aggregated view of a park's docking records for the sidebar list */
export interface ParkDockingSummary {
  parkId: string;
  parkName: string;
  parkLevel: 'national' | 'provincial' | 'pending';
  province: string;
  city: string;
  recordCount: number;
  latestDockedAt: string;
  latestCounterpartyOrg: string;
}
